import { ServiceResponse } from "./serviceResponse.js";

/**
 * Request body used for creating a new page/post comment.
 */
export class CreateCommentRequest {
  constructor(data = {}) {
    if (!data.pageId) {
      throw new Error('CreateCommentRequest requires a pageId field.');
    }
    if (!data.comment || !data.comment.trim()) {
      throw new Error('CreateCommentRequest requires a non-empty comment field.');
    }

    this.pageId = data.pageId;
    this.comment = data.comment.trim();
    this.fullName = data.fullName ?? null;
    this.email = data.email ?? null;
    this.parentId = data.parentId ?? null;
    this.userId = data.userId ?? null;
  }

  toPayload() {
    return {
      pageId: this.pageId,
      comment: this.comment,
      fullName: this.fullName ?? undefined,
      email: this.email ?? undefined,
      parentId: this.parentId ?? undefined,
      userId: this.userId ?? undefined,
    };
  }
}

/**
 * Represents a single comment item.
 */
export class PageComment {
  constructor(data = {}) {
    this.id = typeof data.pageCommentId === 'number' ? data.pageCommentId : 0;
    this.pageId = typeof data.pageId === 'number' ? data.pageId : 0;
    this.fullName = data.fullName ?? '';
    this.email = data.email ?? '';
    this.userId = typeof data.userId === 'number' ? data.userId : null;
    this.parentId = typeof data.parentId === 'number' ? data.parentId : null;
    this.comment = data.comment ?? '';
    this.createDate = data.createDate ?? null;
    this.isAdminRead = Boolean(data.isAdminRead);
    this.isConfirm = Boolean(data.isConfirm);
    this.children = Array.isArray(data.inverseParent)
      ? data.inverseParent.map((item) => new PageComment(item))
      : [];
  }
}

/**
 * Tuple returned by the comments endpoint containing meta information.
 */
export class CommentListTuple {
  constructor(data = {}) {
    this.total = typeof data.item1 === 'number' ? data.item1 : 0;
    this.pageSize = typeof data.item2 === 'number' ? data.item2 : 0;
    this.comments = Array.isArray(data.comments)
      ? data.comments.map((item) => new PageComment(item))
      : [];
  }
}

/**
 * Response wrapper returned by `/api/Post/ShowComments`.
 */
export class CommentsResponse extends ServiceResponse {
  constructor(data = {}) {
    super(data);
    this.data = data.data ? new CommentListTuple(data.data) : new CommentListTuple();
  }
}
